export const attachmentPolicyInformationBlockedAccess = "mbc";
export default {attachmentPolicyInformationBlockedAccess};